<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        NUDGES
        <small>View All Nudges</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">View All Nudges</li>
      </ol>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <div class="col-xs-12 col-lg-10 col-lg-offset-1">
                <table v-show="allNudges.length" class="table table-striped table-apps">
                  <thead>
                    <th>Category</th>
                    <th>Message</th>
                    <th>From</th>
                    <th>To</th>
                    <th>Requires Response</th>
                    <th>View</th>
                  </thead>
                  <tbody>
                    <tr v-for="(nudge, index) in allNudges" :key="index">
                      <td>{{nudge.category}}</td>
                      <td>{{nudge.message.eng}}</td>
                      <td>{{formatDate(nudge.dateFrom)}}</td>
                      <td>{{formatDate(nudge.dateTo)}}</td>
                      <td>{{nudge.requiresResponse}}</td>
                      <td><router-link class="btn btn-primary" :to="`nudge?nudge=${nudge.id}`">View</router-link></td>
                    </tr>
                  </tbody>
                </table>

                <h4 v-if="!processing && !allNudges.length">No Nudge has been created yet</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.row -->
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'AllNudges',
  data () {
    return {
      processing: true
    }
  },
  computed: {
    ...mapState({
      allNudges: state => state.nudge.allNudges
    })
  },
  methods: {
    /**
     * @function formatDate
     * @description formats the date coming from mongodb
     * @param {string} date - the date value stored in db
     */
    formatDate (date) {
      if (!date) {
        return ''
      }
      const theDate = new Date(date)
      return `${theDate.getDate()}/${theDate.getMonth() + 1}/${theDate.getFullYear()}`
    },
    ...mapActions([
      'getAllNudges'
    ])
  },
  async mounted () {
    await this.getAllNudges()
    this.processing = false
  }
}
</script>



// WEBPACK FOOTER //
// view.vue?3211c056